import http from '../_http'

const faq = {
  //default
  summaryFaq: (m) => { return http.get(`manager/board/faq`, m); },
  listFaq: (m) => { return http.post(`manager/board/faq/list`, m); },
  detailFaq: (m) => { return http.get(`manager/board/faq/${m.id}`); },


  //crud
  insertFaq: (m) => { return http.post(`manager/board/faq`, m); },
  updateFaq: (m) => { return http.put(`manager/board/faq`, m); },
  deleteFaq: (m) => { return http.delete(`manager/board/faq/${m.id}`); },
}

export default faq

export { faq }